import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmptyRFPDepartment, IRFPDepartment } from "./RFPPOCDepartmentMast";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
interface IProps {
  singleData: IRFPDepartment;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const schema = yup.object({
  department: yup.string().trim().required("Department is required"),
  description: yup.string().trim().required("Description is required"),
});
const Form = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<IRFPDepartment>({
    defaultValues: EmptyRFPDepartment,
    resolver: yupResolver(schema),
    shouldFocusError: false,
  });

  useEffect(() => {
    if (props.open) {
      if (props.singleData?.id) {
        reset(props.singleData);
      } else {
        reset(EmptyRFPDepartment);
      }
    }
  }, [props.singleData, props.open, reset]);

  const onSubmit = async (data: IRFPDepartment) => {
    try {
      setLoading(true);
      const isEdit = !!(data as any).id;
      if (isEdit && !isDirty) {
        props.toast.current.show({ severity: "info", summary: "No Changes", detail: "Nothing was changed." });
        props.hideDialog();
        setLoading(false);
        return;
      }
      const payload = {
        department: data.department?.trim(),
        description: data.description?.trim(),
      };
      const addPayload = {
        ...data,
        department: data.department?.trim(),
        description: data.description?.trim(),
      };
      const response = isEdit ? await Fetch(`RFP_POC_Department_Mast/UpdateDepartment/${(data as any).id}`, "PUT", payload, null, props.toast) : await Fetch("RFP_POC_Department_Mast/AddDepartment", "POST", addPayload, null, props.toast);
      if (response) {
        props.setReload(!props.reload);
        onHide();
      }
    } finally {
      setLoading(false);
    }
  };
  const onHide = () => {
    props.hideDialog();
    reset(EmptyRFPDepartment);
  };
  return (
    <>
      <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Edit Department" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
          <JVInput column={3} required label="Department" control={control} name="department" error={errors.department?.message} />
          <div className="field col-12">
            <label>Description</label>
            <Controller name="description" control={control} render={({ field }) => <InputTextarea {...field} rows={4} cols={30} className={errors.description ? "p-invalid w-full" : "w-full"} placeholder="Enter task description" />} />
            {errors.description && <small className="p-error">{errors.description.message}</small>}
          </div>
          <div className="col-12 flex justify-content-end gap-2 mt-3">
            <Button loading={loading} label="SAVE" type="submit" disabled={loading || !isDirty}></Button>
            <Button className=" p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default Form;
